import { createContext, useContext } from 'react';

export interface PersistContextType {
  getLocal: (key: string) => Promise<string | null>;
  setLocal: (key: string, value: string) => Promise<void>;
  removeLocal: (key: string) => Promise<void>;
  getSession: (key: string) => Promise<string | null>;
  setSession: (key: string, value: string) => Promise<void>;
  removeSession: (key: string) => Promise<void>;
}

export const PersistContext = createContext<PersistContextType | null>(null);

export const usePersistContext = () => useContext(PersistContext) as PersistContextType;
